export enum DemoSubdomainVariants {
  Alpha = 'alpha',
  Beta = 'beta',
  Gamma = 'gamma',
  Zeta = 'zeta',
}

export const DEMO_SUBDOMAINS = Object.values(DemoSubdomainVariants);
